import { render, staticRenderFns } from "./GameContentResume.vue?vue&type=template&id=43e16c72"
import script from "./GameContentResume.vue?vue&type=script&lang=js"
export * from "./GameContentResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports